import { type NodeRenderer } from '@contentful/rich-text-react-renderer'
import React from 'react'

export const html: NodeRenderer = (node) => (
  <span dangerouslySetInnerHTML={{ __html: node.value }} />
)
